<template>
  <div class="title-block">
    Êtes-vous sûr de vouloir désactiver
    <span v-if="data.length > 1">ces {{ data.length }} évaluations</span>
    <span v-else v-html="candidateWording" />
    ?
  </div>
  <p class="under-text">
    Pour rappel, désactiver l’évaluation de ce talent l’empêchera d’accéder
    aux tests. Vous récupérerez néanmoins
    {{ data.length }} crédit(s) qui s’ajoutera à votre solde actuel.
  </p>
  <div class="btn-container">
    <Button
      class="secondary outline"
      label="Annuler l’opération"
      @click="emits('close')"
    />
    <Button
      class="primary"
      :label="`Désactiver ${
        data.length > 1 ? 'les évaluations' : 'l\'évaluation'
      }`"
      :loading="state.btnIsLoading"
      @click="desactivateParticipants"
    />
  </div>
</template>

<script setup>
import { reactive, computed, inject } from "vue";
import { useRoute } from "vue-router";
import { useToast } from "vue-toastification";
import { getError } from "@/composables/error.js";
import { useParticipantStore } from "@/stores/participant.js";

const participantStore = useParticipantStore();

const emitter = inject("emitter");

const toast = useToast();

const route = useRoute();

const emits = defineEmits(["close", "confirm"]);

const state = reactive({
  btnIsLoading: false,
});

const props = defineProps({
  data: {
    type: Array,
    required: true,
  },
});

const candidateWording = computed(() => {
  let candidate;

  if (props.data[0].candidate_id) {
    candidate = `${props.data[0].candidate.first_name} ${props.data[0].candidate.last_name}`;
  } else if (
    props.data[0].pending_first_name &&
    props.data[0].pending_last_name
  ) {
    candidate = `${props.data[0].pending_first_name} ${props.data[0].pending_last_name}`;
  } else {
    candidate = props.data[0].pending_email;
  }

  return `l'évaluation de <span class="primary-color bold">${candidate}</span>`;
});

async function desactivateParticipants() {
  state.btnIsLoading = true;

  const resp = await participantStore.desactivateParticipants(
    route.params.companyId,
    route.params.spaceId,
    route.params.campaignId,
    props.data.map((elt) => elt.participant_id)
  );

  if (resp.code) {
    toast.error(getError(resp.key));
  } else {
    toast.success(
      props.data.length > 1
        ? "L’évaluation des talents ont bien été désactivées."
        : "L’évaluation du talent a bien été désactivée."
    );

    if (props.data.length > 1) emitter.emit("confirmBulk");
  }

  emits("close");

  state.btnIsLoading = true;
}
</script>
